import fn_core from '../../frontend/src/fn_core';

class fn extends fn_core {
    get_tipus() {
//        var row = $(e.currentTarget);
//        var r = parseInt(row.rVal());
        var r = $('#gj_gyartmany').val();
        var gy = $('#gj_datum').val();
        var mt = $('#gj_motortipus').val();
        console.log('gyartas', gy, mt);
        var post_data;
        if (r != 0) {
            post_data = {
                gy : r,
                date : gy,
                mt : mt
            }
            var o = engine.ajaxFunc('get_tipus', post_data);
            console.log('ajax', o);
//            $.each( o, function( key, value ) {
            $('#tb_gj_tipus').find('select').selSetOp(o).selectmenu('refresh', true);
//                $('#gj_tipus').append(new Option(value, key));
//            });
        }
    }
    
    get_cm3() {
//        var row = $(e.currentTarget);
//        var r = parseInt(row.rVal());
        var gy = $('#gj_datum').val();
        var t = $('#gj_tipus').val();
        var mt = $('#gj_motortipus').val();
        console.log('tipus', t, mt);
        var post_data;
        if (t != 0) {
            post_data = {
                t : t,
                date : gy,
                mt : mt
            }
            var o = engine.ajaxFunc('get_cm3', post_data);
            console.log('ajax', o);
//            $.each( o, function( key, value ) {
            $('#tb_gj_cm3').find('select').selSetOp(o).selectmenu('refresh', true);
//                $('#gj_tipus').append(new Option(value, key));
//            });
        }
    }
    
    set_evesfutas() {
        return;
        var data = $('#gj_evesfutas').clone();
        var dataVal = $('#gj_evesfutas').val();
        var trow = $('#gj_evesfutas_kulfold');
        var erow = $('#gj_evesfutas');
        var sessVal = trow.data('loaded');
        var kedv = $('#kedv_120').val();
        erow.find('option[value=100]').remove();
        erow.selectmenu('refresh', true);
console.log('set:evesfutas');
        trow.find('option').remove();
        trow.selectmenu('refresh', true);

//        if (kedv == 0) trow.append($('<option></option>').attr('value',100).text('Nem használom külföldön'));
        if(dataVal != 6) {
            $.each(data.children(), function(){
                if(this.value == sessVal) {
                    trow.append($('<option></option>').attr('selected','selected').attr('value',this.value).text(this.text));
                }
                else {
                    trow.append($('<option></option>').attr('value',this.value).text(this.text));
                }
                if(this.value == dataVal) {
                    return false;
                }
            });
            trow.selectmenu('refresh', true);
        }
        else {
            $.each(data.children(), function(){
                trow.append($('<option></option>').attr('value',this.value).text(this.text));
            });
            trow.selectmenu('refresh', true);
        }

    }
    
    rendszam_van_change(e) {
        console.log('rendszam_van_change');
        var row = $('#tb_gj_fajta_gfb');
        var trow = $('#rendszam_van');
        var kotok = ['10', '11', '12', '14', '19'];
        var gfb_ok = $('#gfb_oka').val();
        var casco_ok = $('#tb_casco_vege_ok');
        var rv = row.rVal();
        var gf = ['33', '34', '95'];
        console.log('gf', gf, 'rv', rv, 'position', $.inArray(rv, gf));

        if (!gfb_ok) {
            gfb_ok = engine.ajaxFunc('get_session_val', {'id': 'gfb_oka'}, false);
            gfb_ok = gfb_ok.value;
            if (gfb_ok) {
                gfb_ok = gfb_ok.toString();
            }
        }
        console.log('gfb_ok: ', gfb_ok);
        if ($.inArray(rv, gf) == -1) {
            console.log('remove_kell');
            trow.find('option[value=\'0\']').remove();
            trow.selectmenu('refresh', true);
            trow.trigger('updatelayout').trigger('change');
        }
        else {
            if (trow.find('option[value=\'0\']').length == 0) {
                console.log('nincs option');
                trow.append($('<option></option>').attr('value','0').attr('selected', true).text('nem'));
                trow.selectmenu('refresh', true);
                trow.trigger('updatelayout').trigger('change');
            }
        }
        if ($.inArray(gfb_ok, kotok) > -1 || $.inArray(casco_ok.rVal(), kotok) > -1) {
            console.log('remove_kell 2-es érték');
            trow.find('option[value=\'2\']').remove();
            trow.selectmenu('refresh', true);
            trow.trigger('updatelayout').trigger('change');
        }
        else {
            if (trow.find('option[value=\'2\']').length == 0) {
                trow.append($('<option></option>').attr('value','2').text('nem, még nincs forgalomban'));
                trow.selectmenu('refresh', true);
                trow.trigger('updatelayout').trigger('change');
            }
        }
        
        if (gfb_ok == 12 || casco_ok.rVal == 12) {
            $('#tb_rendszam_van').hide();
        }
        if ($.inArray(rv, gf) > -1) {
            $('#tb_rendszam_van').show();
        }

    }
    
    get_feddij(e) {
        $('form').on('click','.next', function (e, c) {
            if (c == 'confirmed') return;
            console.log('get_feddij');
            var elozo_szerz_kezd = $('#elozo_gfb_kezd').val();
            var tulaj_szerz_datum = $('#gj_tulajdon_datum').val();
            var kock_kezdet = $('#gfb_kockazat').val();
            var megszunes_datum = $('#megszunes_datum').val();
            var evfordulo_datum = $('#evfordulo_datum').val();
            var gj_cm3 = $('#gj_cm3').val();
            if (gj_cm3 == -1) gj_cm3 = $('#gj_cm3_egyeb').val();
            var gj_kw = $('#gj_kw').val();
            if (gj_kw == -1) gj_kw = $('#gj_kw_egyeb').val();
            var gj_fajta = $('#gj_fajta_gfb').val();
            var gj_ossztomeg = $('#gj_ossztomeg').val();
            var post_data;
            post_data = {
                elozo_szerz_kezd : elozo_szerz_kezd,
                tulaj_szerz_datum : tulaj_szerz_datum,
                kock_kezdet : kock_kezdet,
                megszunes_datum : megszunes_datum,
                evfordulo_datum : evfordulo_datum,
                gj_cm3 : gj_cm3,
                gj_kw : gj_kw,
                gj_fajta : gj_fajta,
                gj_ossztomeg : gj_ossztomeg
            }
            var o = engine.ajaxFunc('getFedDij', post_data);
            if (o.fedDij == 0) return;
            e.preventDefault();
            engine.popMsg(o.html);
//            console.log('ret: ', ret);
//            if (ret) {
//                $('#pop_msg').popup('close');
//                $('.next').click();
////                $(engine.settings.form.id).trigger('submit');
//            }
//            else {
//                $('#pop_msg').popup('close');
//            }
//            $('#pop_msg-popup').on('click', function (e) {
//                $(engine.settings.form.id).trigger('submit');
//            });
            
        });
        $('#pop_msg').on('click', '.ui-btn', function (e) {
           if ($(e.currentTarget).hasClass('ell')) engine.popMsg('');
           else $(engine.settings.form.id).trigger('submit', 'confirmed')
        });
    }
    
    get_indexdij() {
       console.log('get_indexdij');
       var kotvenyszam = $('#elozo_gfb_kotvenyszam').val();
       var biztosito = $('#elozo_gfb_biztosito').val();
       if (!kotvenyszam) {
           var ksz = engine.ajaxFunc('get_session_val', {'id': 'elozo_gfb_kotvenyszam'}, false);
           kotvenyszam = ksz.value;
       }
       if (!biztosito) {
           var bizt = engine.ajaxFunc('get_session_val', {'id': 'elozo_gfb_biztosito'}, false);
           biztosito = bizt.value;
       }
       var post_data;
       post_data = {
           kotvenyszam : kotvenyszam,
           biztosito : biztosito,
       }
       var o = engine.ajaxFunc('getIndexDij', post_data);

       if(typeof o != 'undefined' && o.IndexDij && o.IndexDij > 0) {
           var txt = engine.fn.format1k(o.IndexDij) + ' Ft';
           console.log('index_dij_message', txt);
           $('#index_dij_message').html(txt);
       }
       else {
           console.log('index_dij_message', 'A biztosító nem szolgáltat index díjat');
           $('#index_dij_message').html('A biztosító nem szolgáltat index díjat');
       }
       console.log('index: ', o);
    }
    
    check_contracts() {
        var sel = {1:'4',2:'4',3:'3',4:'8',5:'4',6:'4',7:'6',8:'3',9:'3',10:'9',11:'18',12:'3'};
        var row = $('#tb_kedv_296');
        console.log('kedv_296', row);
        if (typeof engine.row[row.data('id')] == 'undefined') {
            return;
        }
        var data = engine.row[row.data('id')].kedv296;
        
        console.log('check_contracts', data);

        var i = {
            1 : 1291845642,
            2 : 1291845635,
            3 : 1291845653,
            4 : 1291845653,
            5 : 1291845636,
            6 : 1291845657,
            7 : 1291845634,
            8 : 1291845651,
            9 : 1291845662,
            10 : 1291845662,
            11 : 1291845653,
            12 : 1291845632
        };
        var ret = {};
        $.each(sel, function(k, v) {
            if (data && i[k] in data) {
                var count = 0;
                $.each(data[i[k]], function() {
                    count++;
                });
                ret[k] = count;
                console.log('kedv darab', ret[k]);
            }
            else {
                ret[k] = 0;
            }
        });
        if(ret['9'] && ret['9'] < 10) {
            ret['10'] = 0;
        }
        if(ret['9'] && ret['9'] >= 10) {
            ret['9'] = 0;
        }
        console.log('contract darab', ret);

        var x = false;
        $.each(sel, function(k, v) {
            if(ret[k] * 1 > v * 1 && $('#kedv_296').find("option[value='" + k + "']").is(':visible')) {
                x++;
//                console.log('db: ', ret[k], 'mezo: ', k);
//                option[value=\'2\']
                $('#kedv_296').find("option[value='" + k + "']").prop('selected', 'selected');
//                $('#kedv_296').find("option[value='" + k + "']").attr('disabled', 'disabled');
                $('#kedv_296').selectmenu('refresh', true);
            }
        });
        if (x) {
//            e.preventDefault();
            var msg = 'Tisztelt Ügyfelük! Rendszerünk szerint Ön több érvényes biztosítással rendelkezik egy adott biztosítónál, így ezt bejelöltük Ön helyett. Amennyiben van olyan járműve, ami már nincs az Ön tulajdonában, úgy kérjük a CLB ügyfélkapuban szíveskedjék lezárni a szerződést.';
            engine.popMsg(msg);
        }
    }
    
    kieg_process() {
        var d = {};
        $.each(engine.rowmap, function (i, did) {
            if (did.indexOf('kieg_') !== 0 && did.indexOf('_fizmod') == -1 && did.indexOf('_kockazat') == -1) return;
            d[did] = $('#tb_' + did).rVal();
        });
        d.wait_icon = true;
//        d.async = true;
        $('#tb_kiegDij').cmd('kiegProc', d); // bármelyik kieg row jó
    }
    
    kieg_show(row, d) {
        $('.ui-block-b').removeClass("ui-disabled");
        console.log('kieg_show',d);
        if (typeof d == 'object' && d.success == 1) {
            row.find('.loading_value').removeClass("noprice");
            row.find('.loading_value').text(engine.fn.format1k(d.dij) + ' Ft');
//            row.find('.value').text(engine.fn.format1k(d.orig_dij) + ' Ft');
        } else {
            row.find('.loading_value').addClass("noprice");
            row.find('.loading_value').text('A biztosító nem adott díjat!');
        }
        engine.fn.basket_change();
//        row.find('.loading_value').addClass("noprice");
//        row.find('.loading_value').text((typeof d != 'object' || !d.success) ? 'A biztosító nem adott díjat!' : (engine.fn.format1k(d.dij)
//         + ' Ft'));
        if(typeof d == 'object' && !d.success){
           $('.ui-block-b').addClass("ui-disabled");
        }
    }
    
    basket_change() {
        var val = [];
        val[0] = 'gj';

        var response = engine.ajaxFunc('Basket', val);
        console.log('BASKET:', response);
        if ($('#cartBox').length) {
           $('#cartBox').replaceWith(response.html);
        } else {
           $('#call-back-placeholder').after(response.html);
        }
        console.log('basket_change');
    }
    
    set_jovo_evi_bm() {
        var bm_fokozat = $('#bm_fokozat').val();
//        if (bm_fokozat == 'undefined' || !bm_fokozat) return;
        var kedv_82 = $('#kedv_82').val();
        var karok_0_kifizetes = '-';
        if ($('#tb_karok_0_kifizetes').is(':visible')) karok_0_kifizetes = $('#karok_0_kifizetes').val();
        var karok_0_kifdatum = '-';
        if ($('#tb_karok_0_kifizetes_datum').is(':visible')) karok_0_kifdatum = $('#karok_0_kifizetes_datum').val();
        var karok_0_visszafizetes = '-';
        if ($('#tb_karok_0_visszafizetes').is(':visible')) karok_0_visszafizetes = $('#karok_0_visszafizetes').val();
        var karok_0_gj_fajta = '-';
        if ($('#tb_karok_0_gj_fajta').is(':visible')) karok_0_gj_fajta = $('#karok_0_gj_fajta').val();
        var karok_0_datum = '-';
        if ($('#tb_karok_0_datum').is(':visible')) karok_0_datum = $('#karok_0_datum').val();
        var karok_0_rendszam = '-';
        if ($('#tb_karok_0_gj_rendszam').is(':visible')) karok_0_rendszam = $('#karok_0_gj_rendszam').val();
        var karok_1_kifizetes = '-';
        if ($('#tb_karok_1_kifizetes').is(':visible')) karok_1_kifizetes = $('#karok_1_kifizetes').val();
        var karok_1_kifdatum = '-';
        if ($('#tb_karok_1_kifizetes_datum').is(':visible')) karok_1_kifdatum = $('#karok_1_kifizetes_datum').val();
        var karok_1_visszafizetes = '-';
        if ($('#tb_karok_1_visszafizetes').is(':visible')) karok_1_visszafizetes = $('#karok_1_visszafizetes').val();
        var karok_1_gj_fajta = '-';
        if ($('#tb_karok_1_gj_fajta').is(':visible')) karok_1_gj_fajta = $('#karok_1_gj_fajta').val();
        var karok_1_datum = '-';
        if ($('#tb_karok_1_datum').is(':visible')) karok_1_datum = $('#karok_1_datum').val();
        var karok_1_rendszam = '-';
        if ($('#tb_karok_1_gj_rendszam').is(':visible')) karok_1_rendszam = $('#karok_1_gj_rendszam').val();
        var karok_2_kifizetes = '-';
        if ($('#tb_karok_2_kifizetes').is(':visible')) karok_2_kifizetes = $('#karok_2_kifizetes').val();
        var karok_2_kifdatum = '-';
        if ($('#tb_karok_2_kifizetes_datum').is(':visible')) karok_2_kifdatum = $('#karok_2_kifizetes_datum').val();
        var karok_2_visszafizetes = '-';
        if ($('#tb_karok_2_visszafizetes').is(':visible')) karok_2_visszafizetes = $('#karok_2_visszafizetes').val();
        var karok_2_gj_fajta = '-';
        if ($('#tb_karok_2_gj_fajta').is(':visible')) karok_2_gj_fajta = $('#karok_2_gj_fajta').val();
        var karok_2_datum = '-';
        if ($('#tb_karok_2_datum').is(':visible')) karok_2_datum = $('#karok_2_datum').val();
        var karok_2_rendszam = '-';
        if ($('#tb_karok_2_gj_rendszam').is(':visible')) karok_2_rendszam = $('#karok_2_gj_rendszam').val();
        var karok_3_kifizetes = '-';
        if ($('#tb_karok_3_kifizetes').is(':visible')) karok_3_kifizetes = $('#karok_3_kifizetes').val();
        var karok_3_kifdatum = '-';
        if ($('#tb_karok_3_kifizetes_datum').is(':visible')) karok_3_kifdatum = $('#karok_3_kifizetes_datum').val();
        var karok_3_visszafizetes = '-';
        if ($('#tb_karok_3_visszafizetes').is(':visible')) karok_3_visszafizetes = $('#karok_3_visszafizetes').val();
        var karok_3_gj_fajta = '-';
        if ($('#tb_karok_3_gj_fajta').is(':visible')) karok_3_gj_fajta = $('#karok_3_gj_fajta').val();
        var karok_3_datum = '-';
        if ($('#tb_karok_3_datum').is(':visible')) karok_3_datum = $('#karok_3_datum').val();
        var karok_3_rendszam = '-';
        if ($('#tb_karok_3_gj_rendszam').is(':visible')) karok_3_rendszam = $('#karok_3_gj_rendszam').val();
        
        var post_data;
        $('#jovo_evi_bm').val(bm_fokozat);
        
        post_data = {
            bm_fokozat : bm_fokozat,
            kedv_82 : kedv_82,
            karok_0_kifizetes : karok_0_kifizetes,
            karok_1_kifizetes : karok_1_kifizetes,
            karok_2_kifizetes : karok_2_kifizetes,
            karok_3_kifizetes : karok_3_kifizetes,
            karok_0_visszafizetes : karok_0_visszafizetes,
            karok_1_visszafizetes : karok_1_visszafizetes,
            karok_2_visszafizetes : karok_2_visszafizetes,
            karok_3_visszafizetes : karok_3_visszafizetes,
            karok_0_gj_fajta : karok_0_gj_fajta,
            karok_1_gj_fajta : karok_1_gj_fajta,
            karok_2_gj_fajta : karok_2_gj_fajta,
            karok_3_gj_fajta : karok_3_gj_fajta,
            karok_0_datum : karok_0_datum,
            karok_1_datum : karok_1_datum,
            karok_2_datum : karok_2_datum,
            karok_3_datum : karok_3_datum,
            karok_0_kifdatum : karok_0_kifdatum,
            karok_1_kifdatum : karok_1_kifdatum,
            karok_2_kifdatum : karok_2_kifdatum,
            karok_3_kifdatum : karok_3_kifdatum,
            karok_0_rendszam : karok_0_rendszam,
            karok_1_rendszam : karok_1_rendszam,
            karok_2_rendszam : karok_2_rendszam,
            karok_3_rendszam : karok_3_rendszam
        }
        var o = engine.ajaxFunc('set_jovo_evi_bm', post_data);
        if (typeof o == 'undefined' || !o.success) return;

        $('#jovo_evi_bm').val(o.bm);
        $('#jovo_evi_bm').selectmenu('refresh', true);
    }
    
    set_elozmeny_dij() {
        var bizt = $('#elozo_gfb_biztosito').val();
        var ekotveny = $('#elozo_gfb_kotvenyszam').val();
        if (bizt == '1291845636') {
            var gfb_oka = engine.ajaxFunc('get_session_val', {'id': 'gfb_oka'}, false);
            var elozmeny_dij = $('#elozmeny_dij').val();
            var elozo_szerz_kezd = $('#elozo_gfb_kezd').val();
            if (gfb_oka.value == 11) {
                var o = engine.ajaxFunc('getFedDij', {elozo_szerz_kezd : elozo_szerz_kezd});
                console.log('fed díj', o.fedDij);
            }
            if (ekotveny.length > 4 && (elozmeny_dij <= 0 || elozmeny_dij == 'undefined' || elozmeny_dij == '')) {
                var dij = engine.ajaxFunc('get_generali_dij', {'kotvenyszam': ekotveny});
                if (dij.evesDij > 0) {
                    $('#elozmeny_dij').val(parseInt(dij.evesDij));
                }
            }
            var megszunes = engine.ajaxFunc('get_session_val', {'id': 'megszunes_datum'}, false);
            var volt_gj = engine.ajaxFunc('get_session_val', {'id': 'volt_gj'}, false);
            
            if (volt_gj == 15) {
                var kell_dij = engine.ajaxFunc('generali_kell_dij', {'megszunes' : megszunes, elozo_szerz_kezd : elozo_szerz_kezd});
                if(kell_dij && (parseInt(elozmeny_dij) < 100 || elozmeny_dij == '')) {
                    
                }
            }
        }
    }
    
    get_tulajdon_popup(e) {
        $('form').on('click','.next', function (e, c) {
            console.log('get_tulajdon_popup_1');
            if (c == 'confirmed') return;
            var tulaj_szerz_datum = $('#gj_tulajdon_datum').val();
            var post_data;
            post_data = {
                tulaj_szerz_datum : tulaj_szerz_datum,
            }
            console.log('get_tulajdon_popup_2');
            var o = engine.ajaxFunc('getTulajdonMessage', post_data);
            if (typeof o == 'undefined' || !o.success) return;
            e.preventDefault();
            engine.popMsg(o.msg);
            
        });
        $('#pop_msg').on('click', '.ui-btn', function (e) {
            if ($(e.currentTarget).hasClass('ell')) engine.popMsg('');
            else $(engine.settings.form.id).trigger('submit', 'confirmed')
        });
    }
    
    kedv_class() {
        var kivetel = ['szerzodo_email', 'szerzodo_email_', 'szerzodo_tel', 'szerzodo_tel_', 'szerzodo_gyerek_datum', 'lakc_1', 'lakc_2'];
        var level_1 = ['kedv_ekom', 'kedv_szerzodo', 'kedv_alt_bizt', 'kedv_bizt'];
        var level_2_bizt = ['kedv_aegon', 'kedv_allianz', 'kedv_generali', 'kedv_genertel', 'kedv_groupama', 'kedv_kobe', 'kedv_posta', 'kedv_signal', 'kedv_union', 'kedv_uniqa', 'kedv_waberer'];
        var level_2 = ['kedv_340', 'kedv_340_', 'szerzodo_email', 'szerzodo_email_', 'kedv_46', 'szerzodo_tel', 'szerzodo_tel_', 'kedv_119', 'szerzodo_gyerek_datum', 'kedv_131', 'kedv_53', 'kedv_51', 'kedv_21', 'lakc_1',
        'kedv_139', 'lakc_2', 'kedv_358', 'kedv_69', 'kedv_127', 'kedv_296', 'kedv_349', 'kedv_364', 'kedv_357', 'kedv_240', 'kedv_350', 'kedv_350_', 'kedv_362', 'kedv_394'];
//        var level_3 = ['kedv_314', 'kedv_314_', 'kedv_316', 'kedv_316_', 'kedv_294', 'kedv_326', 'kedv_348', 'kedv_342', 'kedv_162', 'kedv_205',
//        'kedv_274', 'kedv_274_', 'kedv_371',
//        'kedv_184', 'kedv_183', 'kedv_185', 'kedv_223', 'kedv_259', 'kedv_284', 'kedv_285', 'kedv_353', 'kedv_244', 'kedv_246', 'kedv_365', 'kedv_370',
//        'kedv_186', 'kedv_369',
//        'kedv_59', 'kedv_135', 'kedv_336',
//        'kedv_22', 'kedv_75', 'kedv_76'];
        console.log('kedv rows: ', engine.rowmap);
        $.each(engine.rowmap, function (i, did) {
            if (did.indexOf('kedv_') > -1 || $.inArray(did, kivetel) > -1) {
                if ($.inArray(did, level_1) > -1) {
                    $('#tb_' + did).addClass('kedv_level_1');
                }
                else if ($.inArray(did, level_2_bizt) > -1) {
                    $('#tb_' + did).addClass('kedv_level_2');
                    $('#tb_' + did).addClass('biztosito');
                }
                else if ($.inArray(did, level_2) > -1) {
                    $('#tb_' + did).addClass('kedv_level_2');
                }
                else {
                    $('#tb_' + did).addClass('kedv_level_3');
                }
            }
        });
    }
    
    groupama_kieg_change() {
        var kiegs = {'kieg_680' : $('#kieg_680').val(), 'kieg_681' : $('#kieg_681').val(), 'kieg_682' : $('#kieg_682').val()};
        var x = 0;
        
        $.each(kiegs, function (k, v) {
            if (v > 0) {
                x ++;
            }
        });
        if (x == 2) {
            $.each(kiegs, function (k, v) {
                if (v <= 0) {
                    $('#tb_' + k).hide();
                }
                else $('#tb_' + k).show();
            });
        }
        else {
            $.each(kiegs, function (k, v) {
                $('#tb_' + k).show();
            });
        }
    }
    
    set_casco_kotok() {
        var gfb_oka = $('#gfb_oka').val();
        var casco_oka = $('#casco_vege_ok').val();
        if ((casco_oka == '' || casco_oka == '-') && typeof casco_oka != 'undefined') {
            if (gfb_oka == 8 || gfb_oka == 12) {
                $('#casco_vege_ok').val(gfb_oka);
                $('#casco_vege_ok').selectmenu('refresh', true);
            }
        }
    }
    
    set_title() {
        var title = engine.ajaxFunc('get_session_val', {'id': 'mod_title'}, false);
        console.log('title: ', title);
        document.title = title.value;
    }
    
    chk_alvazszam() {
        $(engine.settings.form.id).on('click','.next', function (e, c) {
           var alvazszam = $('#gj_alvazszam').val();
           if (c == 'confirmed') return;
         
           if (alvazszam.length != 17) {
               var msg = "<table class='alc'><div><h2>Figyelmeztetés</h2></div><div>Az alvázszám nem 17 karakter hosszú. Biztos, hogy helyesen adta meg az alvázszámot?</div><tr class='actions'><td colspan=3><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-arrow-l ui-btn-icon-left ell'>Ellenőrzöm az adatokat</div><div class='ui-btn ui-input-btn ui-corner-all ui-shadow ui-icon-check ui-btn-icon-right ok'>Helyesek a megadott adatok</div></td></tr></table>";

               e.preventDefault();
               engine.popMsg(msg);
           }
        });
        $('#pop_msg').on('click', '.ui-btn', function (e) {
           if ($(e.currentTarget).hasClass('ell')) engine.popMsg('');
           else $(engine.settings.form.id).trigger('submit', 'confirmed')
        });
    }
    
    allin_opt(e) {
        var row = $(e.currentTarget);
        var va = row.rVal();
        var trow = $('#kieg_383');
        var eltuntet = false;
        var kiegek = ['384', '396', '386', '387', '388', '389', '390', '391', '392', '393', '394', '395', '385', '739', '397', '405', '406', '407', '408', '572', '573'];
        
        $.each(kiegek, function(k, v) {
            if ($('#kieg_' + v).val() == 1) {
                eltuntet = true;
            }
        });
        if (eltuntet) {
            trow.find('option[value=\'0\']').remove();
            trow.selectmenu('refresh', true);
            trow.trigger('updatelayout').trigger('change');
        }
        else {
            trow.append($('<option></option>').attr('value','0').text('Elrejtem a listát'));
            trow.selectmenu('refresh', true);
            trow.trigger('updatelayout').trigger('change');
        }
    }
    
    kockakezdet_datepicker(){
        $('.kockakezdet').each(function(){
            console.log('kockakezdet', $(this));

            $(this).datepicker($(this).data('datepicker'));
        });
    }
    kockakezdet_vege_text(){
        if($('#gj_fajta_h').length){
            $('#gj_fajta_h,#gfb_kockazat').on('change', function() {
                var jogalapcsoport = parseInt($('#gj_fajta_h').val());
                //próba: +1 év
                //kivitelre szánt: +29 nap

                if(jogalapcsoport == 1 || jogalapcsoport == 3){
                    var kezdet = new Date($('#gfb_kockazat').val()+" 00:00:00");
                    if($('#gfb_kockazat').val() != ""){

                        var vege = new Date();

                        if(jogalapcsoport == 1){
                            kezdet.setFullYear(kezdet.getFullYear() + 1);
                        }
                        if(jogalapcsoport == 3){
                            kezdet.setDate(kezdet.getDate() + 29);
                        }
                        vege = kezdet;

                        var yr      = vege.getFullYear();

                        var monthInt = vege.getMonth()+1;

                        var month   = monthInt < 10 ? '0' + monthInt : monthInt;
                        var day     = vege.getDate()  < 10 ? '0' + vege.getDate()  : vege.getDate();
                        var newDate = yr + '-' + month + '-' + day;

                        $('#gfb_kockazat_vege_readonly').html(newDate);
                    }
                }
            });
        }
    }
    change_kieg_741() {
        var kieg_741 = $('#kieg_741').val();
        if (kieg_741 != 1) {
            console.log('kedv_742 val 1: ', $('#kieg_742').val());
            $('#kieg_742').val(0);
            $('#kieg_742').find("option[value='0']").prop('selected', 'selected');
            $('#kieg_742').selectmenu().selectmenu('refresh', true);
            console.log('kedv_742 val 2: ', $('#kieg_742').val());
        }
        else {
            $('#kieg_742').val(1);
            $('#kieg_742').find("option[value='1']").prop('selected', 'selected');
            $('#kieg_742').selectmenu().selectmenu('refresh', true);
        }
        $('#tb_kieg_742').trigger('updatelayout').trigger('change');
        
//        engine.fn.basket_change();
    }
    
    show_kedv_394() {
        $('#tb_kedv_394').hide();
        var szerzodo_neme = $('#szerzodo_neme').val();
        var jogsi_datum = $('#szerzodo_jogsi_datum').val();
        var szerzodo_szn = $('#szerzodo_szn').val();
        var post_data;
        post_data = {
            szerzodo_neme : szerzodo_neme,
            jogsi_datum : jogsi_datum,
            szerzodo_szn : szerzodo_szn
        }
        console.log('394_data', post_data);
        var o = engine.ajaxFunc('get_kedv_394', post_data);
        if (typeof o == 'undefined' || !o.success) return;
        console.log('394_ajax', o);
        if (o.kell) {
            $('#tb_kedv_394').show();
        }
        else {
            $('#tb_kedv_394').hide();
            $('#kedv_394').val(0);
        }
    }
}


export default fn